import { API_CONSTANTS, API_METHODS, deleteApiCall, postApiCall, putApiCall } from "../../config/api-constants";
import { fetchCall } from "../../utils/ajax";
import { apiCall, apiCallPut } from "../../utils/action";
export const UPDATE_TE_DATA = "UPDATE_TE_DATA";
export const UPDATE_CATEGORY_DATA = "UPDATE_CATEGORY_DATA";
export const GET_TEMPLATE_LIST = "GET_TEMPLATE_LIST";
export const ENABLE_GLOBAL_RATING = "ENABLE_GLOBAL_RATING";
export const REORDER_RATINGS = "REORDER_RATINGS";
export const REORDER_RATINGS_LIST = "REORDER_RATINGS_LIST";
export const GET_RATINGS_LIST = "GET_RATINGS_LIST";
export const ADD_MULTIPLE_GLOBAL_RATING = "ADD_MULTIPLE_GLOBAL_RATING";
export const CREATE_GLOBAL_RATING = "CREATE_GLOBAL_RATING";
export const UPDATE_GLOBAL_RATING = "UPDATE_GLOBAL_RATING";

export const updateTEData = (updatedData) => {
  return { type: UPDATE_TE_DATA, payload: updatedData || [] };
};

export const updateCategoryData = (updatedData) => {
  return { type: UPDATE_CATEGORY_DATA, payload: updatedData || [] };
};

export const addIntroDropdown = (data) => {
  return async (dispatch) => {
    let response;
    if (data.type === "add") {
      delete data.type;
      response = await postApiCall(API_CONSTANTS.ADD_INTRO_DROPDOWN, data);
    }
    else if (data.type === "edit") {
      delete data.type;
      response = await putApiCall(API_CONSTANTS.ADD_INTRO_DROPDOWN, data);
    }
    else if (data.type === "delete") {
      delete data.type;
      response = await deleteApiCall(API_CONSTANTS.ADD_INTRO_DROPDOWN, data);
    }
    return dispatch({
      type: "ADD_INTRO_DROPDOWN",
      payload: response,
    });
  }
}

export const enableGlobalRating = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      apiCall(
        (response) => {
          const success = response?.data?.success;
          const message = response?.data?.message;
          if (!success) {
            reject(new Error(message || "Failed to enable global ratings"));
            return;
          }
          dispatch({ type: ENABLE_GLOBAL_RATING, payload: true });
          resolve(response.data);
        },
        null,
        "ENABLE_GLOBAL_RATING"
      );
    });
  };
};

export const reorderRatings = (payload) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      apiCallPut(
        (response) => {
          const success = response?.data?.success;
          const message = response?.data?.message;
          if (!success) {
            reject(new Error(message || "Failed to reorder ratings"));
            return;
          }
          dispatch({ type: REORDER_RATINGS, payload: payload.rating_data });
          resolve(response.data);
        },
        payload,
        "REORDER_RATINGS_GR"
      );
    });
  };
};

export const reorderRatingsList = (payload) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      apiCall(
        (response) => {
          const success = response?.data?.success;
          const message = response?.data?.message;
          if (!success) {
            reject(new Error(message || "Failed to reorder ratings"));
            return;
          }
          dispatch({ type: REORDER_RATINGS_LIST, payload: payload.reordered_ratings });
          resolve(response.data);
        },
        payload,
        "REORDER_RATINGS_LIST"
      );
    });
  };
};

export const GetTemplateList = (payload) => {
  return async (dispatch) => {
    const url = `${API_CONSTANTS.GET_TEMPLATE_LIST_VIEW}`;
    const method = API_METHODS.POST;
    return await fetchCall((response) => {
          return dispatch({ type: GET_TEMPLATE_LIST, payload: response.data });
        },
        url,
        method,
        payload
      );
    };
  };

export const GetRatingsList = () => {
  return async (dispatch) => {
    const companyId = sessionStorage.getItem("company_id");
    const url = `${API_CONSTANTS.GET_RATINGS}?company_id=${companyId}`;
    const method = API_METHODS.GET;
    return await fetchCall((response) => {
        return dispatch({ type: GET_RATINGS_LIST, payload: response.data });
      },
      url,
      method
    );
  };
};

export const addMultipleGlobalRating = (payload) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      apiCall(
        (response) => {
          const success = response?.data?.success;
          const message = response?.data?.message;
          if (!success) {
            reject(new Error(message || "Failed to add ratings"));
            return;
          }
          dispatch({ type: ADD_MULTIPLE_GLOBAL_RATING, payload: payload.rating_data });
          resolve(response.data);
        },
        payload,
        "ADD_MULTIPLE_GLOBAL_RATING"
      );
    });
  };
};

export const createGlobalRating = (payload) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      fetchCall(
        (response) => {
          const success = response?.data?.success;
          const message = response?.data?.message;
          if (!success) {
            reject(new Error(message || "Failed to create rating"));
            return;
          }
          dispatch({ type: CREATE_GLOBAL_RATING, payload: response?.data?.data });
          resolve(response.data);
        },
        `${API_CONSTANTS.GET_RATINGS}`,
        API_METHODS.POST,
        payload
      );
    });
  };
};

export const updateGlobalRating = (id, payload) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      fetchCall(
        (response) => {
          const success = response?.data?.success;
          const message = response?.data?.message;
          if (!success) {
            reject(new Error(message || "Failed to update rating"));
            return;
          }
          dispatch({ type: UPDATE_GLOBAL_RATING, payload: { id, ...payload } });
          resolve(response.data);
        },
        `${API_CONSTANTS.GET_RATINGS}/${id}`,
        API_METHODS.PUT,
        payload
      );
    });
  };
};
